/* eslint-disable camelcase */
// node modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';

// app modules: components
import CollectionImage from 'components/CollectionImage';
import CollectionOptionsMenu from 'components/Collection/OptionsMenu';
import FavouriteButton from 'components/FavouriteButton';
import Icon from 'components/Icon';
import Link from 'components/Link';

// app modules: props
import CollectionsProps from 'components/Collection/CollectionsProps';

// app modules: services
import route from 'services/route';
import assets from 'services/assets';
import { getImageSrc } from 'services/image';

// app modules: constants
import { COLOURS, CONTENT_TYPES } from 'constants/index';

// assets
import CssCollectionCollectionItem from './CollectionItem.scss';

class CollectionCollectionItem extends PureComponent {
  static propTypes = {
    item: CollectionsProps.collection.isRequired,
    mobileViewAsList: PropTypes.bool,
    referrer: PropTypes.string,
    section: PropTypes.string,
  };

  static defaultProps = {
    mobileViewAsList: false,
    referrer: null,
    section: null,
  };

  render() {
    const { mobileViewAsList, referrer, section } = this.props;
    const collection = this.props.item;
    const { items_count } = collection;
    const image = (
      <CollectionImage
        mobileAsThumbnail
        contentImage={collection.cover_image}
        overrideImage={collection.custom_cover_image}
        width={250}
        height={250}
        bookCoverWidth={175}
        bookCoverHeight={175}
      />
    );

    let imageToShare;
    const imageOptions = {
      width: 1024,
      height: 1024,
    };
    if (collection.custom_cover_image) {
      imageToShare = assets.collectionUrl(collection.custom_cover_image, imageOptions);
    } else if (collection.cover_image?.primary_image) {
      imageToShare = getImageSrc(
        collection.cover_image.primary_image,
        'square',
        size => size.w >= 250,
        {
          searchHighToLow: true,
        },
      );
    }
    return (
      <div
        className={classNames('collection-item', {
          'collection-item--mobile-list': mobileViewAsList,
        })}
      >
        <Link
          className={classNames('collection-item__wrapper', {
            'collection-item--mobile-list__wrapper': mobileViewAsList,
          })}
          to={route.collection.view(collection)}
          referrer={referrer}
          section={section}
        >
          <div
            className={classNames('collection-item__image', {
              'collection-item--mobile-list__image': mobileViewAsList,
            })}
          >
            {image}
          </div>

          <div
            className={classNames('collection-item__body', {
              'collection-item--mobile-list__body': mobileViewAsList,
            })}
          >
            <header
              className={classNames('collection-item__header', {
                'collection-item--mobile-list__header': mobileViewAsList,
              })}
            >
              {collection.name}
            </header>

            <footer
              className={classNames('collection-item__footer', {
                'collection-item--mobile-list__footer': mobileViewAsList,
              })}
            >
              {collection.display_name && !collection.display_name.includes('@') ? (
                <p
                  className={classNames('collection-item__paragraph', {
                    'collection-item--mobile-list__paragraph': mobileViewAsList,
                  })}
                >
                  {collection.display_name}
                </p>
              ) : null}
              {items_count && typeof items_count.total === 'number' ? (
                <p
                  className={classNames('collection-item__paragraph', {
                    'collection-item--mobile-list__paragraph': mobileViewAsList,
                  })}
                >
                  {`${items_count.total} ${items_count.total === 1 ? 'item' : 'items'}`}
                </p>
              ) : null}
            </footer>
          </div>
        </Link>
        {/* Interactive elements are overlayed using CSS to avoid nesting them inside the <a> tag. */}
        <div
          className={classNames('collection-item__actions-wrapper', {
            'collection-item--mobile-list__actions-wrapper': mobileViewAsList,
          })}
        >
          <div
            className={classNames('collection-item__actions', {
              'collection-item--mobile-list__actions': mobileViewAsList,
            })}
          >
            <FavouriteButton
              contentId={`${collection.id}`}
              contentType={CONTENT_TYPES.COLLECTION}
            />
            <CollectionOptionsMenu
              collection={collection}
              image={image}
              heading={collection.name}
              shareImageUrl={imageToShare}
            >
              <Icon fill={COLOURS.ENERGIZED} name="dots" height="20" width="20" />
            </CollectionOptionsMenu>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(CssCollectionCollectionItem)(CollectionCollectionItem);
